if ( /Edge\/|Trident\/|MSIE /.test( window.navigator.userAgent ) ) {
	//Include object-fit-images for IE.
	import('object-fit-images').then( ( { default: objectFitImages } ) => {
		// Initialize object-fit-images
		objectFitImages();
	} )
}